import './index.scss';
import TabView from '../TabView';
import SoccerTabView from './SoccerTabView';
import CricketTabView from './CricketTabView';
import TennisTabView from './TennisTabView';
import AllSportsTabView from './AllSportsTabView';
import { PRIVATE_EVENTS, PUBLIC_EVENTS } from '../../handlers/EventManager/constants';
export default class FixtureWidgetMulti {
    constructor(sportsManager, fullPageFixturesConfig) {
        this.tabView = null;
        this.sportsManager = sportsManager;
        this.eventManager = this.sportsManager.eventManager;
        this.fullPageFixturesConfig = fullPageFixturesConfig;
        this.assetConfig = this.fullPageFixturesConfig.assetConfig;
        this.jsonConfig = this.fullPageFixturesConfig.jsonManagerConfig;
        this.parentDom = document.getElementById(this.assetConfig.parentId);
        this.widgetCallback = this.assetConfig.widgetCallback;

        if(!this.parentDom){
            this.eventManager.broadcastPublicEvent(PUBLIC_EVENTS.SPORTS_MANAGER_ERROR, {
                errorCode: 'err_100',
                errorMessage: 'DOM element required to render tab view.',
            });
        }

        this.handleCTAClick = this.assetConfig.handleClick
        this.reminderIds = this.assetConfig.reminderId
        this.sportId = this.assetConfig.sportId;
        this.tourId = this.assetConfig.tourId;
    }

    destroyFixtureMultiSDK() {
        if(this.parentDom) {
            this.parentDom.innerHTML = "";
            this.eventManager.broadcastPrivateEvent(PRIVATE_EVENTS.FIXTURE_WIDGET_MULTI_DESTROY);
        }
    }
 
    render() {        
        this.tabView = new TabView();
        const element = document.getElementById("fixture-full-page");
        if(element) {
            element.remove();
        }
        const fullPageFixtureCont = document.createElement('div');
        fullPageFixtureCont.setAttribute('id', 'fixture-full-page');
        fullPageFixtureCont.setAttribute('class', 'fixture-full-page-cont');
        this.parentDom.appendChild(fullPageFixtureCont);

        if(document.getElementsByClassName('overlay').length < 1){
            const overlay = document.createElement('div');
            overlay.setAttribute('class', 'overlay');
            overlay.classList.add('display-none');
            this.parentDom.appendChild(overlay);
        }

        this.getTabView(this.sportId);
    }

    getTabView(sportId){
        this.tabView.render("fixture-full-page-cont", sportId, this.reloadSport.bind(this), this.jsonConfig?.sports_config);
        switch(sportId) {
            case "-1":
                this.sportsView = new AllSportsTabView(this.sportsManager, this.fullPageFixturesConfig);
                this.sportsView.getFixtureData("fixture-full-page-cont", this.handleCTAClick, this.reminderIds, this.sportId, this.tourId, this.widgetCallback, this.jsonConfig, this.assetConfig);
                break;
            case "1":
                this.sportsView = new CricketTabView(this.sportsManager, this.fullPageFixturesConfig);
                this.sportsView.getFixtureData("fixture-full-page-cont", this.handleCTAClick, this.reminderIds, this.sportId, this.tourId, this.widgetCallback, this.jsonConfig, this.assetConfig);
                break;
            case "2":
                this.sportsView = new SoccerTabView(this.sportsManager, this.fullPageFixturesConfig);
                this.sportsView.getFixtureData("fixture-full-page-cont", this.handleCTAClick, this.reminderIds, this.sportId, this.tourId, this.widgetCallback, this.jsonConfig, this.assetConfig);
                break;
            case "3":
                this.sportsView = new TennisTabView(this.sportsManager, this.fullPageFixturesConfig);
                this.sportsView.getFixtureData("fixture-full-page-cont", this.handleCTAClick, this.reminderIds, this.sportId, this.tourId, this.widgetCallback, this.jsonConfig, this.assetConfig); 
                break; 
            default:
                this.sportsView = new AllSportsTabView(this.sportsManager, this.fullPageFixturesConfig);
                this.sportsView.getFixtureData("fixture-full-page-cont", this.handleCTAClick, this.reminderIds, this.sportId, this.tourId, this.widgetCallback, this.jsonConfig, this.assetConfig);
                break;
          }
    }

    reloadSport(sportId, tourId){
        document.getElementById('tab-container').nextElementSibling.remove();
        this.sportsView.destroy();
        this.sportId = sportId;
        this.tourId = tourId;
        this.render();
    }
    
}